import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { UniversalLink } from '@plone/volto/components';
import { searchContent } from '@plone/volto/actions';

const MostReadView = ({ data, block }) => {
  const dispatch = useDispatch();
  const subrequestKey = `agsusMostRead_${block || 'preview'}`;

  const title = data.title || 'Notícias mais vistas';
  const limit = data.limit || 5;
  const parentPath = data.parentPath || '/noticias';
  const portalTypes = (data.portalTypes && data.portalTypes.length > 0)
    ? data.portalTypes
    : ['News Item'];

  const items = useSelector(
    (s) => s.search?.subrequests?.[subrequestKey]?.items || [],
    shallowEqual,
  );

  React.useEffect(() => {
    dispatch(
      searchContent(
        parentPath,
        {
          portal_type: portalTypes,
          sort_on: 'view_count_30d',
          sort_order: 'descending',
          b_size: limit,
          fullobjects: false,
          metadata_fields: ['view_count_30d'],
        },
        subrequestKey,
      ),
    );
  }, [dispatch, parentPath, limit, portalTypes.join(','), subrequestKey]);

  return (
    <aside className="ag-most-read">
      {title && <h2 className="ag-titulo-secao">{title}</h2>}
      {items.length === 0 ? (
        <p className="ag-most-read__empty">
          Sem dados de visualizações ainda.
        </p>
      ) : (
        <ol className="ag-most-read__list">
          {items.slice(0, limit).map((item, idx) => (
            <li key={item['@id']} className="ag-most-read__item">
              <div className="ag-most-read__num">{idx + 1}.</div>
              <div className="ag-most-read__body">
                <UniversalLink
                  href={item['@id']}
                  className="ag-most-read__head"
                >
                  {item.title}
                </UniversalLink>
                {item.description && (
                  <p className="ag-most-read__desc">{item.description}</p>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
    </aside>
  );
};

MostReadView.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    limit: PropTypes.number,
    parentPath: PropTypes.string,
    portalTypes: PropTypes.array,
  }).isRequired,
  block: PropTypes.string,
};

export default MostReadView;
